import React, { useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import L from "leaflet";
import { Table } from "reactstrap";
import { Button } from "@mui/material";
import "leaflet/dist/leaflet.css";
import { Modal } from "react-bootstrap";
import { useGetCrmBankingDocumentsByIdQuery } from "features/onboarding/users/farmer/farmerApiSlice";

// Define custom marker icon
const markerIcon = new L.Icon({
  iconUrl: "https://cdn-icons-png.flaticon.com/512/9410/9410621.png",
  iconSize: [40, 40],
  iconAnchor: [20, 40],
  popupAnchor: [0, -40],
});

const FarmerCattleMap = ({ cattleDetails }) => {
  console.log("cattleDetails",cattleDetails)

  const [id, setId] = useState(""); // State for API ID
  const { data } = useGetCrmBankingDocumentsByIdQuery(id); // Fetch data by ID
  const [modalData, setModalData] = useState({});
  const [isModalOpen, setModalOpen] = useState(false);
  const [center] = useState([28.576592977786234, 77.31433377113422]); // Map center coordinates

  const validLocations = cattleDetails
    ?.map((item) => {
      const assetDetails = item?.asset_details || {};
      return {
        id: item.id,
        fullName: item.asset_owner || "Unknown Farmer",
        cattleSpecies: assetDetails.cattle_species || "N/A",
        cattleAge: assetDetails.cattle_age || "N/A",
        cattleBreed: assetDetails.cattle_breed || "N/A",
        cattleColor: assetDetails.cattle_color || "N/A",
        cattleSumInsured: assetDetails.cattle_sum_insured || "N/A",
        address: assetDetails.address || "N/A",
        latitude: assetDetails.latitude,
        longitude: assetDetails.longitude,
      };
    })
    .filter(
      (item) =>
        item.latitude !== undefined &&
        item.longitude !== undefined &&
        !isNaN(item.latitude) &&
        !isNaN(item.longitude)
    );

  // Handle marker click to show modal
  const handleMarkerClick = (item) => {
    setModalData(item);
    setId(item.id); // Update ID for fetching more data if required
    setModalOpen(true);
  };

  // Close modal
  const handleModalClose = () => {
    setModalOpen(false);
  };

  return (
    <>
      {/* Map Section */}
      <MapContainer
        center={center}
        style={{ height: "55vh", width: "100%" }}
        zoom={13}
      >
        <TileLayer
          url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}"
          attribution="&copy; OpenStreetMap contributors"
        />
        <MarkerClusterGroup chunkedLoading>
          {validLocations?.map((item, index) => (
            <Marker
              key={index}
              position={[item.latitude, item.longitude]}
              icon={markerIcon}
              //   eventHandlers={{
              //     click: () => handleMarkerClick(item),
              //   }}
            >
              <Popup>
                <Table>
                  <tbody>
                    <tr>
                      <th>Farmer Name:</th>
                      <td>{item.fullName}</td>
                    </tr>
                    <tr>
                      <th>Species:</th>
                      <td>{item.cattleSpecies}</td>
                    </tr>
                    <tr>
                      <th>Age:</th>
                      <td>{item.cattleAge}</td>
                    </tr>
                    <tr>
                      <th>Breed:</th>
                      <td>{item.cattleBreed}</td>
                    </tr>
                    <tr>
                      <th>Color:</th>
                      <td>{item.cattleColor}</td>
                    </tr>
                    <tr>
                      <th>Sum Insured:</th>
                      <td>{item.cattleSumInsured}</td>
                    </tr>
                    <tr>
                      <th>Address:</th>
                      <td>{item.address}</td>
                    </tr>
                  </tbody>
                </Table>
              </Popup>
            </Marker>
          ))}
        </MarkerClusterGroup>
      </MapContainer>

      {/* Modal Section */}
      {/* <Modal show={isModalOpen} onHide={handleModalClose}>
        <div className="modal-header">
          <h5 className="modal-title">Cattle Details</h5>
        </div>
        <div className="modal-body">
          <Table>
            <tbody>
              <tr>
                <th>Farmer Name:</th>
                <td>{modalData.fullName}</td>
              </tr>
              <tr>
                <th>Species:</th>
                <td>{modalData.cattleSpecies}</td>
              </tr>
              <tr>
                <th>Age:</th>
                <td>{modalData.cattleAge}</td>
              </tr>
              <tr>
                <th>Breed:</th>
                <td>{modalData.cattleBreed}</td>
              </tr>
              <tr>
                <th>Color:</th>
                <td>{modalData.cattleColor}</td>
              </tr>
              <tr>
                <th>Sum Insured:</th>
                <td>{modalData.cattleSumInsured}</td>
              </tr>
              <tr>
                <th>Address:</th>
                <td>{modalData.address}</td>
              </tr>
            </tbody>
          </Table>
        </div>
        <div className="modal-footer">
          <Button variant="contained" onClick={handleModalClose}>
            Close
          </Button>
        </div>
      </Modal> */}
    </>
  );
};

export default FarmerCattleMap;
